import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgSmileyDuotone = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M24.5 14a10.5 10.5 0 1 1-21 0 10.5 10.5 0 0 1 21 0Z"
      opacity={0.2}
    />
    <path d="M14 2.625A11.375 11.375 0 1 0 25.375 14 11.387 11.387 0 0 0 14 2.625Zm0 21A9.625 9.625 0 1 1 23.625 14 9.636 9.636 0 0 1 14 23.625ZM8.75 11.812a1.313 1.313 0 1 1 2.625 0 1.313 1.313 0 0 1-2.625 0Zm10.5 0a1.313 1.313 0 1 1-2.626 0 1.313 1.313 0 0 1 2.626 0Zm-.118 5.25c-1.126 1.946-2.996 3.063-5.132 3.063-2.136 0-4.006-1.116-5.132-3.063a.875.875 0 1 1 1.514-.875c.817 1.412 2.101 2.188 3.618 2.188s2.801-.777 3.618-2.188a.874.874 0 1 1 1.514.875Z" />
  </svg>
);
export default SvgSmileyDuotone;
